import withErrorBoundary from 'components/shared/withErrorBoundary';
import { FC, Fragment, useEffect, useState } from 'react';
import { Range } from 'react-range';

interface FlightResultFilterSliderProps {
  filter: any;
  onChange: (filter: any) => void;
  minStr: string;
  maxStr: string;
  type:
    | 'price'
    | 'duration'
    | 'departureInboundTime'
    | 'departureOutboundTime'
    | 'stopDuration'
    | 'arrivalInboundTime'
    | 'arrivalOutboundTime';
}

const FlightResultFilterSlider: FC<FlightResultFilterSliderProps> = ({
  filter,
  onChange,
  type,
  ...props
}) => {
  const [values, setValues] = useState(filter[type]?.value);
  const colorContrast = getComputedStyle(document.body).getPropertyValue('--color-contrast');

  useEffect(() => {
    setValues(filter[type]?.value);
  }, [filter[type]?.value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      {filter[type]?.min !== filter[type]?.max && (
        <Fragment>
          <div className="flight-filter-time text-lh-sm">
            <span>{props.minStr}</span>
            <span>{props.maxStr}</span>
          </div>
          <Range
            step={1}
            rtl={localStorage.getItem('language') !== 'en'}
            min={filter[type]?.min}
            max={filter[type]?.max}
            onFinalChange={() =>
              onChange({ ...filter, [type]: { ...filter[type], value: values } })
            }
            values={values!}
            onChange={(values) => setValues(values as [number, number])}
            renderTrack={({ props, children }) => (
              <div
                {...props}
                style={{
                  ...props,
                  height: '4px',
                  width: 'calc(100% - 16px)',
                  margin: '0 8px',
                  backgroundColor: '#ccc',
                }}
              >
                {children}
              </div>
            )}
            renderThumb={({ props }) => (
              <div
                {...props}
                style={{
                  ...props,
                  position: 'absolute',
                  height: '16px',
                  width: '16px',
                  borderRadius: '50%',
                  backgroundColor: colorContrast,
                }}
              />
            )}
          />
          <div className="mb-20"></div>
        </Fragment>
      )}
    </div>
  );
};

export default withErrorBoundary(FlightResultFilterSlider, 'FlightResultFilterSlider');
